import React from 'react';
import { TextField, Autocomplete } from '@mui/material';
import { PORT } from 'constant';

export default ({
  label = 'Port',
  value,
  onChange,
  error,
  style = {},
}) => {
  const changeHandler = (e, newValue) => (
    newValue
      ? onChange(newValue.value)
      : onChange(e.target.value || ''));

  const valueObject = PORT.find((item) => item.value === value) || null;

  return (
    <Autocomplete
      options={PORT.filter((e) => e.value.toString().includes(value))}
      isOptionEqualToValue={(option, val) => (option.value?.toString().includes(val.value?.toString()))}
      getOptionLabel={(e) => (e.value ? `${e.value} - ${e.name}` : '')}
      style={{
        marginTop: 4, marginBottom: 8, ...style,
      }}
      value={valueObject}
      onChange={changeHandler}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant="outlined"
          fullWidth
          value={value}
          onChange={changeHandler}
          error={!!error}
          helperText={error}
        />
      )}
    />
  );
};
